// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { NavLink, useNavigate } from "react-router-dom";
// import { userProductShow } from "../slices/productReducer"; // slice-dan import
// import logo from "../static files/images/AzGlass.png";
// import plus from "../static files/images/plus.png";
// import burger from "../static files/images/burger-menu.png";
// import support from "../static files/images/Support.png";
// import instagram from "../static files/images/Instagram-Logo-PNG-Free-Download.png";
// import facebook from "../static files/images/facebook-logo-facebook-social-media-icon-free-png.png";
// import konum from "../static files/images/KONUM-konum-png-3.png";
// import "../static files/styles/navbar.css";

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);

//   const { product, status, error } = useSelector((state) => state.products);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 50) {
//         // 50px scroll olduqda fon qaralır, istəyə görə dəyiş
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   const dispatch = useDispatch();
//   const navigate = useNavigate(); // subcategory klikləyən zaman details səhifəsinə keçmək üçün

//   const categories = [
//     {
//       id: 1,
//       name: "Pəncərə sistemləri",
//       subcategories: [
//         { name: "Veka pəncərələri", slug: "veka-pencereleri" },
//         { name: "Alüminium izosistem", slug: "aluminium-izosistem" },
//         { name: "Hebe Schiebe", slug: "hebe-schiebe" },
//         { name: "Taxta pəncərələr", slug: "taxta-pencereler" },
//         { name: "Şəbəkə (Karolaj)", slug: "sebeke-karolaj" },
//         { name: "Giyotin pəncərələr", slug: "giyotin-pencereler" },
//       ],
//     },
//     {
//       id: 2,
//       name: "Metal Konstruksiya",
//       subcategories: [
//         { name: "Anbarlar", slug: "anbarlar" },
//         { name: "Metal söhbətgah", slug: "metal-sohbetgah" },
//         { name: "Pilləkən", slug: "pilleken" },
//         { name: "Məhəccər", slug: "meheccer" },
//         { name: "Loft Soft", slug: "loft-soft" },
//         { name: "Avtomatik qapılar", slug: "avtomatik-qapilar" },
//       ],
//     },
//     {
//       id: 3,
//       name: "Fasad sistemləri",
//       subcategories: [
//         { name: "Şüşə fasad (cəbhə)", slug: "suse-fasad-cebhe" },
//         {
//           name: "Alüminium kompozit panel (Alkopon)",
//           slug: "aluminium-kompozit-panel-alkopon",
//         },
//       ],
//     },
//     {
//       id: 4,
//       name: "Məhəccər",
//       subcategories: [
//         { name: "Tökmə alüminium", slug: "tokme-aluminium" },
//         { name: "Şüşə məhəccər", slug: "suse-meheccer" },
//         { name: "Metal məhəccər", slug: "metal-meheccer" },
//       ],
//     },
//     {
//       id: 5,
//       name: "Digər",
//       subcategories: [
//         { name: "Tent-perqola", slug: "tent-perqola" },
//         { name: "İzolyasiya sistemləri", slug: "izolasiya-sistemleri" },
//         { name: "Ağcaqanad torları", slug: "agcaqanad-torlari" },
//         { name: "Cambalkon", slug: "cambalkon" },
//         { name: "Qış bağçaları", slug: "qis-bagcalari" },
//       ],
//     },
//   ];

//   const [openDropdowns, setOpenDropdowns] = useState({});

//   // const toggleDropdown = (id) => {
//   //   setOpenDropdowns((prev) => ({
//   //     ...prev,
//   //     [id]: !prev[id],
//   //   }));
//   // };

//   const toggleDropdown = (id) => {
//     setOpenDropdowns((prev) => {
//       const newState = {};

//       // bütün dropdown-ları bağla
//       Object.keys(prev).forEach((key) => {
//         newState[key] = false;
//       });

//       // yalnız klik olunanı toggle et
//       newState[id] = !prev[id];

//       return newState;
//     });
//   };

//   function stringToSlug(str) {
//     return str
//       .toLowerCase() // Kiçik hərflərə çevir
//       .trim() // Baş və sondakı boşluqları sil
//       .replace(/[\s\W-]+/g, "-") // Boşluqları və xüsusi simvolları '-' ilə əvəz et
//       .replace(/^-+|-+$/g, ""); // Baş və sondakı '-'ləri sil
//   }

//   const handleSubcategoryClick = async (subcategory) => {
//     // dispatch thunk ilə API-dan məlumat al
//     await dispatch(userProductShow(subcategory));
//     const slug = stringToSlug(subcategory);
//     // details səhifəsinə yönləndir
//     setBurgerOpen(false);
//     setOpenDropdowns(false);
//     navigate(`/details/${subcategory}`);
//   };

//   const [burgerOpen, setBurgerOpen] = useState(false);

//   useEffect(() => {
//     if (burgerOpen) {
//       document.documentElement.style.overflow = "hidden"; // <html> scroll bağlanır
//     } else {
//       document.documentElement.style.overflow = "auto"; // scroll açılır
//     }

//     return () => {
//       document.documentElement.style.overflow = "auto"; // cleanup
//     };
//   }, [burgerOpen]);

//   return (
//     <>
//       <header
//         style={burgerOpen ? { backgroundColor: "#181a19" } : {}}
//         className={scrolled ? "scrolled" : ""}
//       >
//         <nav id="navbar">
//           <NavLink
//             to={"/"}
//             className="logo-box"
//             onClick={(e) => {
//               setBurgerOpen(false);
//               window.scrollTo({
//                 top: 0,
//                 behavior: "smooth",
//               });
//             }}
//           >
//             <img className="logo-nav" src={logo} alt="logo" />
//             <div className="texts">
//               <h2>AzGlass Design</h2>
//               <h3>Group Construction</h3>
//             </div>
//           </NavLink>

//           <a className="contact-phone" href="tel:+994502562211">
//             Zəng sifarişi
//             <img className="support-img" src={support} alt="support" />
//           </a>

//           <img
//             className={`burger-menu ${burgerOpen ? "open" : ""}`}
//             src={burger}
//             alt="burger menu"
//             onClick={() => setBurgerOpen((prev) => !prev)}
//           />

//           <ul>
//             {categories.map((cat) => (
//               <li key={cat.id}>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     toggleDropdown(cat.id);
//                   }}
//                 >
//                   {cat.name}
//                 </a>
//                 <img
//                   src={plus}
//                   alt="plus"
//                   onClick={() => toggleDropdown(cat.id)}
//                 />

//                 <div
//                   className="dropdown"
//                   style={{ display: openDropdowns[cat.id] ? "flex" : "none" }}
//                 >
//                   {cat.subcategories.map((sub, index) => (
//                     <a
//                       href="#"
//                       key={index}
//                       onClick={(e) => {
//                         e.preventDefault();
//                         handleSubcategoryClick(sub.slug);
//                       }}
//                     >
//                       {sub.name}
//                     </a>
//                   ))}
//                 </div>
//               </li>
//             ))}

//             <li className="company-link">
//               <NavLink to="/about">Şirkət haqqında</NavLink>
//             </li>
//             <li>
//               <NavLink to="/contact">Əlaqə</NavLink>
//             </li>
//           </ul>

//           <ul className="social-media-ul">
//             <li>
//               <a
//                 href="https://www.instagram.com/azglassgroup.az"
//                 target="__blank"
//                 className="image-box intsagram"
//               >
//                 <img src={instagram} alt="instagram" />
//               </a>
//             </li>
//             <li>
//               <a className="image-box facebook">
//                 <img src={facebook} alt="facebook" />
//               </a>
//             </li>
//             <li>
//               <a href="https://www.google.com/maps?ll=40.392401,49.860821&z=17&t=m&hl=az&gl=AZ&mapclient=embed&q=95+Qaraba%C4%9F+k%C3%BC%C3%A7%C9%99si+Bak%C4%B1" target="__blank" className="image-box tiktok">
//                 <img src={konum} alt="konum" />
//               </a>
//             </li>
//           </ul>

//           {burgerOpen && (
//             <div className="burger-overlay">
//               <ul className="burger-list">
//                 {categories.map((cat) => (
//                   <li
//                     key={cat.id}
//                     style={{
//                       height: openDropdowns[cat.id]
//                         ? `${10 + cat.subcategories.length * 8.5}vw`
//                         : "10vw",
//                       transition: "height 0.3s ease",
//                     }}
//                   >
//                     <div
//                       onClick={() => toggleDropdown(cat.id)}
//                       className="burger-cat"
//                     >
//                       <div className="name">
//                         <a
//                           href="#"
//                           style={{
//                             color: openDropdowns[cat.id]
//                               ? "#157BC6"
//                               : "#ffffff",
//                             transition: "color 0.3s ease",
//                           }}
//                         >
//                           {cat.name}
//                         </a>
//                         <div
//                           className="line"
//                           style={{
//                             width: openDropdowns[cat.id] ? "17.188vw" : "0",
//                             transition: "width 0.3s ease",
//                             border: openDropdowns[cat.id]
//                               ? "0.13vw solid #157BC6"
//                               : "0",
//                           }}
//                         ></div>
//                       </div>
//                       <img
//                         src={plus}
//                         alt="plus"
//                         onClick={() => toggleDropdown(cat.id)}
//                         style={{
//                           transform: openDropdowns[cat.id]
//                             ? "rotate(45deg)"
//                             : "rotate(0deg)",
//                           transition: "0.3s ease",
//                         }}
//                       />
//                     </div>

//                     {openDropdowns[cat.id] && (
//                       <div className="burger-subcategories">
//                         {cat.subcategories.map((sub, idx) => (
//                           <a
//                             href="#"
//                             key={idx}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               handleSubcategoryClick(sub.slug);
//                             }}
//                           >
//                             {sub.name}
//                           </a>
//                         ))}
//                       </div>
//                     )}
//                   </li>
//                 ))}
//                 <li>
//                   <div className="name">
//                     <NavLink
//                       className="about-link"
//                       to={"/about"}
//                       onClick={(e) => {
//                         setBurgerOpen(false);
//                       }}
//                     >
//                       Şirkət haqqında
//                     </NavLink>
//                   </div>
//                 </li>
//                 <li>
//                   <div className="name">
//                     <NavLink
//                       className="contact-link"
//                       to={"/contact"}
//                       onClick={(e) => {
//                         setBurgerOpen(false);
//                       }}
//                     >
//                       Əlaqə
//                     </NavLink>
//                   </div>
//                 </li>
//               </ul>
//             </div>
//           )}
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Navbar;

// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { NavLink, useNavigate } from "react-router-dom";
// import { userProductShow } from "../slices/productReducer";
// import logo from "../static files/images/AzGlass.png";
// import plus from "../static files/images/plus.png";
// import burger from "../static files/images/burger-menu.png";
// import support from "../static files/images/Support.png";
// import instagram from "../static files/images/Instagram-Logo-PNG-Free-Download.png";
// import facebook from "../static files/images/facebook-logo-facebook-social-media-icon-free-png.png";
// import konum from "../static files/images/KONUM-konum-png-3.png";
// import "../static files/styles/navbar.css";

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const { product, status, error } = useSelector((state) => state.products);

//   // ✅ Desktop hover üçün: mouse device-dir ya yox?
//   const [isDesktop, setIsDesktop] = useState(() => {
//     // SSR yoxdu amma yenə safe
//     if (typeof window === "undefined") return true;
//     return window.matchMedia("(hover: hover) and (pointer: fine)").matches;
//   });

//   useEffect(() => {
//     const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
//     const handler = (e) => setIsDesktop(e.matches);

//     // köhnə browser-lar üçün fallback
//     if (mq.addEventListener) mq.addEventListener("change", handler);
//     else mq.addListener(handler);

//     return () => {
//       if (mq.removeEventListener) mq.removeEventListener("change", handler);
//       else mq.removeListener(handler);
//     };
//   }, []);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 50) setScrolled(true);
//       else setScrolled(false);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const categories = [
//     {
//       id: 1,
//       name: "Pəncərə sistemləri",
//       subcategories: [
//         { name: "Veka pəncərələri", slug: "veka-pencereleri" },
//         { name: "Alüminium izosistem", slug: "aluminium-izosistem" },
//         { name: "Hebe Schiebe", slug: "hebe-schiebe" },
//         { name: "Taxta pəncərələr", slug: "taxta-pencereler" },
//         { name: "Şəbəkə (Karolaj)", slug: "sebeke-karolaj" },
//         { name: "Giyotin pəncərələr", slug: "giyotin-pencereler" },
//       ],
//     },
//     {
//       id: 2,
//       name: "Metal Konstruksiya",
//       subcategories: [
//         { name: "Anbarlar", slug: "anbarlar" },
//         { name: "Metal söhbətgah", slug: "metal-sohbetgah" },
//         { name: "Pilləkən", slug: "pilleken" },
//         { name: "Məhəccər", slug: "meheccer" },
//         { name: "Loft Soft", slug: "loft-soft" },
//         { name: "Avtomatik qapılar", slug: "avtomatik-qapilar" },
//       ],
//     },
//     {
//       id: 3,
//       name: "Fasad sistemləri",
//       subcategories: [
//         { name: "Şüşə fasad (cəbhə)", slug: "suse-fasad-cebhe" },
//         {
//           name: "Alüminium kompozit panel (Alkopon)",
//           slug: "aluminium-kompozit-panel-alkopon",
//         },
//       ],
//     },
//     {
//       id: 4,
//       name: "Məhəccər",
//       subcategories: [
//         { name: "Tökmə alüminium", slug: "tokme-aluminium" },
//         { name: "Şüşə məhəccər", slug: "suse-meheccer" },
//         { name: "Metal məhəccər", slug: "metal-meheccer" },
//       ],
//     },
//     {
//       id: 5,
//       name: "Digər",
//       subcategories: [
//         { name: "Tent-perqola", slug: "tent-perqola" },
//         { name: "İzolyasiya sistemləri", slug: "izolasiya-sistemleri" },
//         { name: "Ağcaqanad torları", slug: "agcaqanad-torlari" },
//         { name: "Cambalkon", slug: "cambalkon" },
//         { name: "Qış bağçaları", slug: "qis-bagcalari" },
//       ],
//     },
//   ];

//   const [openDropdowns, setOpenDropdowns] = useState({});

//   const toggleDropdown = (id) => {
//     setOpenDropdowns((prev) => {
//       const newState = {};
//       Object.keys(prev).forEach((key) => (newState[key] = false));
//       newState[id] = !prev[id];
//       return newState;
//     });
//   };

//   const handleSubcategoryClick = async (subcategorySlug) => {
//     await dispatch(userProductShow(subcategorySlug));
//     setBurgerOpen(false);
//     setOpenDropdowns({});
//     navigate(`/details/${subcategorySlug}`);
//   };

//   const [burgerOpen, setBurgerOpen] = useState(false);

//   useEffect(() => {
//     document.documentElement.style.overflow = burgerOpen ? "hidden" : "auto";
//     return () => {
//       document.documentElement.style.overflow = "auto";
//     };
//   }, [burgerOpen]);

//   return (
//     <>
//       <header
//         style={burgerOpen ? { backgroundColor: "#181a19" } : {}}
//         className={scrolled ? "scrolled" : ""}
//       >
//         <nav id="navbar">
//           <NavLink
//             to={"/"}
//             className="logo-box"
//             onClick={() => {
//               setBurgerOpen(false);
//               window.scrollTo({ top: 0, behavior: "smooth" });
//             }}
//           >
//             <img className="logo-nav" src={logo} alt="logo" />
//             <div className="texts">
//               <h2>AzGlass Design</h2>
//               <h3>Group Construction</h3>
//             </div>
//           </NavLink>

//           <a className="contact-phone" href="tel:+994502562211">
//             Zəng sifarişi
//             <img className="support-img" src={support} alt="support" />
//           </a>

//           <img
//             className={`burger-menu ${burgerOpen ? "open" : ""}`}
//             src={burger}
//             alt="burger menu"
//             onClick={() => setBurgerOpen((prev) => !prev)}
//           />

//           {/* ✅ DESKTOP MENU */}
//           <ul>
//             {categories.map((cat) => (
//               <li
//                 key={cat.id}
//                 // ✅ Desktop-da hover olsun deyə: mouse enter/leave-də state açıb bağlayırıq
//                 onMouseEnter={() => {
//                   if (isDesktop) {
//                     setOpenDropdowns({ [cat.id]: true });
//                   }
//                 }}
//                 onMouseLeave={() => {
//                   if (isDesktop) {
//                     setOpenDropdowns({});
//                   }
//                 }}
//               >
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     // ✅ Mobil/touch cihazda click işləsin
//                     if (!isDesktop) toggleDropdown(cat.id);
//                   }}
//                 >
//                   {cat.name}
//                 </a>

//                 <img
//                   src={plus}
//                   alt="plus"
//                   onClick={() => {
//                     // ✅ Mobil/touch cihazda click işləsin
//                     if (!isDesktop) toggleDropdown(cat.id);
//                   }}
//                 />

//                 <div
//                   className={`dropdown ${openDropdowns[cat.id] ? "open" : ""}`}
//                 >
//                   {cat.subcategories.map((sub, index) => (
//                     <a
//                       href="#"
//                       key={index}
//                       onClick={(e) => {
//                         e.preventDefault();
//                         handleSubcategoryClick(sub.slug);
//                       }}
//                     >
//                       {sub.name}
//                     </a>
//                   ))}
//                 </div>
//               </li>
//             ))}

//             <li className="company-link">
//               <NavLink to="/about">Şirkət haqqında</NavLink>
//             </li>
//             <li>
//               <NavLink to="/contact">Əlaqə</NavLink>
//             </li>
//           </ul>

//           <ul className="social-media-ul">
//             <li>
//               <a
//                 href="https://www.instagram.com/azglassgroup.az"
//                 target="__blank"
//                 rel="noreferrer"
//                 className="image-box intsagram"
//               >
//                 <img src={instagram} alt="instagram" />
//               </a>
//             </li>
//             <li>
//               <a className="image-box facebook">
//                 <img src={facebook} alt="facebook" />
//               </a>
//             </li>
//             <li>
//               <a
//                 href="https://www.google.com/maps?ll=40.392401,49.860821&z=17&t=m&hl=az&gl=AZ&mapclient=embed&q=95+Qaraba%C4%9F+k%C3%BC%C3%A7%C9%99si+Bak%C4%B1"
//                 target="__blank"
//                 rel="noreferrer"
//                 className="image-box tiktok"
//               >
//                 <img src={konum} alt="konum" />
//               </a>
//             </li>
//           </ul>

//           {/* ✅ BURGER MENU (mobil) — eyni qalsın */}
//           {burgerOpen && (
//             <div className="burger-overlay">
//               <ul className="burger-list">
//                 {categories.map((cat) => (
//                   <li
//                     key={cat.id}
//                     style={{
//                       height: openDropdowns[cat.id]
//                         ? `${10 + cat.subcategories.length * 8.5}vw`
//                         : "10vw",
//                       transition: "height 0.3s ease",
//                     }}
//                   >
//                     <div
//                       onClick={() => toggleDropdown(cat.id)}
//                       className="burger-cat"
//                     >
//                       <div className="name">
//                         <a
//                           href="#"
//                           style={{
//                             color: openDropdowns[cat.id]
//                               ? "#157BC6"
//                               : "#ffffff",
//                             transition: "color 0.3s ease",
//                           }}
//                           onClick={(e) => e.preventDefault()}
//                         >
//                           {cat.name}
//                         </a>
//                         <div
//                           className="line"
//                           style={{
//                             width: openDropdowns[cat.id] ? "17.188vw" : "0",
//                             transition: "width 0.3s ease",
//                             border: openDropdowns[cat.id]
//                               ? "0.13vw solid #157BC6"
//                               : "0",
//                           }}
//                         ></div>
//                       </div>
//                       <img
//                         src={plus}
//                         alt="plus"
//                         onClick={() => toggleDropdown(cat.id)}
//                         style={{
//                           transform: openDropdowns[cat.id]
//                             ? "rotate(45deg)"
//                             : "rotate(0deg)",
//                           transition: "0.3s ease",
//                         }}
//                       />
//                     </div>

//                     {openDropdowns[cat.id] && (
//                       <div className="burger-subcategories">
//                         {cat.subcategories.map((sub, idx) => (
//                           <a
//                             href="#"
//                             key={idx}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               handleSubcategoryClick(sub.slug);
//                             }}
//                           >
//                             {sub.name}
//                           </a>
//                         ))}
//                       </div>
//                     )}
//                   </li>
//                 ))}
//                 <li>
//                   <div className="name">
//                     <NavLink
//                       className="about-link"
//                       to={"/about"}
//                       onClick={() => setBurgerOpen(false)}
//                     >
//                       Şirkət haqqında
//                     </NavLink>
//                   </div>
//                 </li>
//                 <li>
//                   <div className="name">
//                     <NavLink
//                       className="contact-link"
//                       to={"/contact"}
//                       onClick={() => setBurgerOpen(false)}
//                     >
//                       Əlaqə
//                     </NavLink>
//                   </div>
//                 </li>
//               </ul>
//             </div>
//           )}
//         </nav>
//       </header>
//     </>
//   );
// };

// export default Navbar;



import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { userProductShow } from "../slices/productReducer";
import logo from "../static files/images/AzGlass.png";
import plus from "../static files/images/plus.png";
import burger from "../static files/images/burger-menu.png";
import support from "../static files/images/Support.png";
import instagram from "../static files/images/Instagram-Logo-PNG-Free-Download.png";
import facebook from "../static files/images/facebook-logo-facebook-social-media-icon-free-png.png";
import konum from "../static files/images/KONUM-konum-png-3.png";
import "../static files/styles/navbar.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const { product, status, error } = useSelector((state) => state.products);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navRef = useRef(null);

  const categories = [
    {
      id: 1,
      name: "Pəncərə sistemləri",
      subcategories: [
        { name: "Veka pəncərələri", slug: "veka-pencereleri" },
        { name: "Alüminium izosistem", slug: "aluminium-izosistem" },
        { name: "Hebe Schiebe", slug: "hebe-schiebe" },
        { name: "Taxta pəncərələr", slug: "taxta-pencereler" },
        { name: "Şəbəkə (Karolaj)", slug: "sebeke-karolaj" },
        { name: "Giyotin pəncərələr", slug: "giyotin-pencereler" },
      ],
    },
    {
      id: 2,
      name: "Metal Konstruksiya",
      subcategories: [
        { name: "Anbarlar", slug: "anbarlar" },
        { name: "Metal söhbətgah", slug: "metal-sohbetgah" },
        { name: "Pilləkən", slug: "pilleken" },
        { name: "Məhəccər", slug: "meheccer" },
        { name: "Loft Soft", slug: "loft-soft" },
        { name: "Avtomatik qapılar", slug: "avtomatik-qapilar" },
      ],
    },
    {
      id: 3,
      name: "Fasad sistemləri",
      subcategories: [
        { name: "Şüşə fasad (cəbhə)", slug: "suse-fasad-cebhe" },
        {
          name: "Alüminium kompozit panel (Alkopon)",
          slug: "aluminium-kompozit-panel-alkopon",
        },
      ],
    },
    {
      id: 4,
      name: "Məhəccər",
      subcategories: [
        { name: "Tökmə alüminium", slug: "tokme-aluminium" },
        { name: "Şüşə məhəccər", slug: "suse-meheccer" },
        { name: "Metal məhəccər", slug: "metal-meheccer" },
      ],
    },
    {
      id: 5,
      name: "Digər",
      subcategories: [
        { name: "Tent-perqola", slug: "tent-perqola" },
        { name: "İzolyasiya sistemləri", slug: "izolasiya-sistemleri" },
        { name: "Ağcaqanad torları", slug: "agcaqanad-torlari" },
        { name: "Cambalkon", slug: "cambalkon" },
        { name: "Qış bağçaları", slug: "qis-bagcalari" },
      ],
    },
  ];

  const [openDropdowns, setOpenDropdowns] = useState({});
  const [burgerOpen, setBurgerOpen] = useState(false);

  // Scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) setScrolled(true);
      else setScrolled(false);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Burger open olarkən scroll bağla
  useEffect(() => {
    document.documentElement.style.overflow = burgerOpen ? "hidden" : "auto";
    return () => {
      document.documentElement.style.overflow = "auto";
    };
  }, [burgerOpen]);

  // ✅ Outside click: navbar-dan kənara klik olunsa dropdown bağlansın
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (!navRef.current) return;

      // nav daxilindədirsə bağlama
      if (navRef.current.contains(e.target)) return;

      // nav xaricindədirsə bağla
      setOpenDropdowns({});
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, []);

  const toggleDropdown = (id) => {
    setOpenDropdowns((prev) => {
      const newState = {};

      // hamısını bağla
      Object.keys(prev).forEach((key) => (newState[key] = false));

      // klik olunanı toggle et
      newState[id] = !prev[id];

      return newState;
    });
  };

  const handleSubcategoryClick = async (subcategorySlug) => {
    await dispatch(userProductShow(subcategorySlug));
    setBurgerOpen(false);
    setOpenDropdowns({});
    navigate(`/details/${subcategorySlug}`);
  };

  return (
    <>
      <header
        style={burgerOpen ? { backgroundColor: "#181a19" } : {}}
        className={scrolled ? "scrolled" : ""}
      >
        <nav id="navbar" ref={navRef}>
          <NavLink
            to={"/"}
            className="logo-box"
            onClick={() => {
              setBurgerOpen(false);
              setOpenDropdowns({});
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img className="logo-nav" src={logo} alt="logo" />
            <div className="texts">
              <h2>AzGlass Design</h2>
              <h3>Group Construction</h3>
            </div>
          </NavLink>

          <a className="contact-phone" href="tel:+994502562211">
            Zəng sifarişi
            <img className="support-img" src={support} alt="support" />
          </a>

          <img
            className={`burger-menu ${burgerOpen ? "open" : ""}`}
            src={burger}
            alt="burger menu"
            onClick={() => {
              setBurgerOpen((prev) => !prev);
              setOpenDropdowns({});
            }}
          />

          {/* Desktop menu (click) */}
          <ul>
            {categories.map((cat) => (
              <li key={cat.id}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleDropdown(cat.id);
                  }}
                >
                  {cat.name}
                </a>

                <img
                  src={plus}
                  alt="plus"
                  onClick={() => toggleDropdown(cat.id)}
                  style={{
                    transform: openDropdowns[cat.id]
                      ? "rotate(45deg)"
                      : "rotate(0deg)",
                    transition: "0.3s ease",
                  }}
                />

                <div
                  className={`dropdown ${openDropdowns[cat.id] ? "open" : ""}`}
                >
                  {cat.subcategories.map((sub, index) => (
                    <a
                      href="#"
                      key={index}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSubcategoryClick(sub.slug);
                      }}
                    >
                      {sub.name}
                    </a>
                  ))}
                </div>
              </li>
            ))}

            <li className="company-link">
              <NavLink
                to="/about"
                onClick={() => {
                  setBurgerOpen(false);
                  setOpenDropdowns({});
                }}
              >
                Şirkət haqqında
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/contact"
                onClick={() => {
                  setBurgerOpen(false);
                  setOpenDropdowns({});
                }}
              >
                Əlaqə
              </NavLink>
            </li>
          </ul>

          <ul className="social-media-ul">
            <li>
              <a
                href="https://www.instagram.com/azglassgroup.az"
                target="__blank"
                rel="noreferrer"
                className="image-box intsagram"
              >
                <img src={instagram} alt="instagram" />
              </a>
            </li>
            <li>
              <a className="image-box facebook">
                <img src={facebook} alt="facebook" />
              </a>
            </li>
            <li>
              <a
                href="https://www.google.com/maps?ll=40.392401,49.860821&z=17&t=m&hl=az&gl=AZ&mapclient=embed&q=95+Qaraba%C4%9F+k%C3%BC%C3%A7%C9%99si+Bak%C4%B1"
                target="__blank"
                rel="noreferrer"
                className="image-box tiktok"
              >
                <img src={konum} alt="konum" />
              </a>
            </li>
          </ul>

          {/* Burger menu (mobil) — eyni qalsın */}
          {burgerOpen && (
            <div className="burger-overlay">
              <ul className="burger-list">
                {categories.map((cat) => (
                  <li
                    key={cat.id}
                    style={{
                      height: openDropdowns[cat.id]
                        ? `${10 + cat.subcategories.length * 8.5}vw`
                        : "10vw",
                      transition: "height 0.3s ease",
                    }}
                  >
                    <div
                      onClick={() => toggleDropdown(cat.id)}
                      className="burger-cat"
                    >
                      <div className="name">
                        <a
                          href="#"
                          style={{
                            color: openDropdowns[cat.id]
                              ? "#157BC6"
                              : "#ffffff",
                            transition: "color 0.3s ease",
                          }}
                          onClick={(e) => e.preventDefault()}
                        >
                          {cat.name}
                        </a>
                        <div
                          className="line"
                          style={{
                            width: openDropdowns[cat.id] ? "17.188vw" : "0",
                            transition: "width 0.3s ease",
                            border: openDropdowns[cat.id]
                              ? "0.13vw solid #157BC6"
                              : "0",
                          }}
                        ></div>
                      </div>
                      <img
                        src={plus}
                        alt="plus"
                        onClick={() => toggleDropdown(cat.id)}
                        style={{
                          transform: openDropdowns[cat.id]
                            ? "rotate(45deg)"
                            : "rotate(0deg)",
                          transition: "0.3s ease",
                        }}
                      />
                    </div>

                    {openDropdowns[cat.id] && (
                      <div className="burger-subcategories">
                        {cat.subcategories.map((sub, idx) => (
                          <a
                            href="#"
                            key={idx}
                            onClick={(e) => {
                              e.preventDefault();
                              handleSubcategoryClick(sub.slug);
                            }}
                          >
                            {sub.name}
                          </a>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
                <li>
                  <div className="name">
                    <NavLink
                      className="about-link"
                      to={"/about"}
                      onClick={() => {
                        setBurgerOpen(false);
                        setOpenDropdowns({});
                      }}
                    >
                      Şirkət haqqında
                    </NavLink>
                  </div>
                </li>
                <li>
                  <div className="name">
                    <NavLink
                      className="contact-link"
                      to={"/contact"}
                      onClick={() => {
                        setBurgerOpen(false);
                        setOpenDropdowns({});
                      }}
                    >
                      Əlaqə
                    </NavLink>
                  </div>
                </li>
              </ul>
            </div>
          )}
        </nav>
      </header>
    </>
  );
};

export default Navbar;